module.exports = __webpack_public_path__ + "static/media/btn-disconn.7f34cff6.svg";